// Filter checkbox

$(function () {
    
    $(document).on('click', '.jsFilterCheckbox', function (e) {
        e.preventDefault();
        const $href = $(this).attr('href');
        const $ajaxHref = $(this).data('ajax-href');
        const $ajaxTarget = $(this).closest('.jsFilterCheckboxTarget');

        if (typeof $ajaxHref != 'undefined') {
            EUCUtils.reload($ajaxHref, $ajaxTarget, $href);
        }
        else if (typeof $href !== 'undefined') {
            window.location.href = $href;
        };
    });
});
